/**
 * Devolve o nome do plano "puro", pronto para ser prefixado por quem exibe.
 *
 * Duas limpezas:
 * 1. Remove o sufixo "com VSL Dinâmica" (variação comercial do mesmo plano).
 * 2. Remove um prefixo "Plano " redundante — parte dos nomes é gravada com ele
 *    ("Plano Brinde") e parte não ("Light"), e os call sites escrevem
 *    `Plano ${nome}`, o que produzia "Plano Plano Brinde".
 *
 * Quem exibe deve continuar escrevendo o prefixo; esta função só garante que
 * ele não venha duplicado.
 */
export const normalizePlanName = (name?: string | null): string => {
  const semVariacao = (name || '')
    .replace(/\s*com\s+VSL\s+Din[âa]mic[ao]/gi, '')
    .trim();

  // Só descarta o prefixo se sobrar algo depois dele: um plano chamado
  // apenas "Plano" continua sendo devolvido como "Plano".
  const semPrefixo = semVariacao.replace(/^plano\s+/i, '').trim();

  return semPrefixo || semVariacao;
};
